import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'

interface ConfirmDeleteStopModalProps {
  placeName: string
}

function ConfirmDeleteStopModal({ placeName }: ConfirmDeleteStopModalProps) {
  const intl = useIntl()
  const modalElement = useModalElementContext<boolean>()

  const handleClose = useCallback(() => {
    modalElement.resolve(false)
  }, [modalElement])

  const handleConfirm = useCallback(() => {
    modalElement.resolve(true)
  }, [modalElement])

  const deleteStopTitle = intl.formatMessage({
    id: '14wSqocPGHQvw1I4BJ4g',
    defaultMessage: 'Delete stop?',
    description: 'Title for the confirm delete stop modal in trip planner',
  })
  const deleteLabel = intl.formatMessage({
    id: 'FPKnfObag3XAJK8typSO',
    defaultMessage: 'Delete',
    description: 'Primary action button label to confirm deleting a stop',
  })
  const cancelLabel = intl.formatMessage({
    id: 'e9rPULNZLi70XoXoUH8f',
    defaultMessage: 'Cancel',
    description: 'Secondary action button label to cancel deleting a stop',
  })

  return (
    <Modal
      title={deleteStopTitle}
      primaryActionText={deleteLabel}
      secondaryActionText={cancelLabel}
      onPrimaryActionClick={handleConfirm}
      onSecondaryActionClick={handleClose}
      onClose={handleClose}
      tabletHeight="auto"
    >
      <BodyText variant="medium">
        <FormattedMessage
          id="XL-9SsxCNb6PRN0tBxYM"
          defaultMessage="Are you sure you want to delete <bold>{placeName}</bold> from your itinerary?"
          description="Confirmation message when deleting a stop from the trip itinerary"
          values={{
            placeName,
            bold: (chunks: React.ReactNode) => <b>{chunks}</b>,
          }}
        />
      </BodyText>
    </Modal>
  )
}

export default ConfirmDeleteStopModal
